module.exports = __webpack_public_path__ + "static/media/mountadex-combined-iphonex.b1cbafd4.png";